<template>

    <div class="galaxy::common-canvas-editor-ModeAndViewportToolbar tw-shrink-0">

        <div class="btn-group">

            <button
                    class="btn tw-outline-none tw-cursor-pointer"
                    type="button"
                    :class="{ 'btn-info': activeMode == 'overview' }"
                    @click="onOverviewClick"
                    title="Bekijk en bewerk de content vanaf een afstand.">
                <i class="far fa-search-minus"></i>
                <span>Overzicht</span>
            </button>

            <button
                    class="btn tw-outline-none tw-cursor-pointer"
                    :class="{ 'btn-info': activeMode == 'content' }"
                    @click="$emit('update:activeMode', 'content')"
                    title="Bewerk de individuele blokken op detailniveau.">
                <i class="far fa-pencil"></i>
                <span>Content</span>
            </button>

        </div>

        <div class="btn-group ml-2">

            <button v-for="(viewport, id) in viewports"
                    class="btn outline-none cursor-pointer"
                    :class="{ 'btn-info': activeViewport == id }"
                    type="button"
                    :title="viewport.title"
                    @click="setActiveViewport(id)">
                <i class="far fa-fw" :class="viewport.icon"></i>
            </button>

        </div>

    </div>

</template>

<script>

    export default {

        props: {
            activeMode: String,
            activeViewport: String,
        },

        data()
        {
            return {
                viewports: {
                    xs: { icon: 'fa-mobile', title: 'Mobiel' },
                    sm: { icon: 'fa-tablet', title: 'Tablet rechtopstaand' },
                    md: { icon: 'fa-tablet fa-rotate-90', title: 'Tablet gedraaid' },
                    lg: { icon: 'fa-laptop', title: 'Laptop' },
                    xl: { icon: 'fa-desktop', title: 'Desktop' },
                },
            };
        },

        methods:
        {
            setActiveViewport(id)
            {
                // Abort due to no change?
                if(this.activeViewport == id)
                    return;

                // Set
                this.$emit('update:activeViewport', id);

                // Go to edit mode since overview does not support this mode?
                if(this.activeMode == 'overview')
                    this.$emit('update:activeMode', 'content');
            },

            onOverviewClick()
            {
                // Update active mode.
                this.$emit('update:activeMode', 'overview')

                this.setActiveViewport(_.last(Object.keys(this.viewports)));
            },
        },

        watch: {

            'activeMode'(newVal, oldVal)
            {
                // Set to XL for a good preview?
                if(newVal == 'overview')
                    this.setActiveViewport(_.last(Object.keys(this.viewports)));
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-ModeAndViewportToolbar {

        button {
            box-shadow: none !important;
            outline: none !important;

            &:not(.btn-info) {
                background: #f3f2f2;
            }

            span {
                @apply tw-ml-1;
            }
        }

    }

</style>